





























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import '@/compiled-icons/format-align-center';
import '@/compiled-icons/format-align-left';
import '@/compiled-icons/format-align-right';
import '@/compiled-icons/toy-brick-plus-outline';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';

import '@/compiled-icons/add';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';

@Component({
  name: 'dynamic-document-table-list-field-template',
  components: {
    DynamicDocumentRowsDesignerTemplate: () => import('@/views/dynamicdocuments/dynamic-document-rows-designer-template.vue'),
    AmetrasDateFieldTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentListTableFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2 | undefined;
  @Prop({required: false}) readonly: boolean | undefined;

}
